import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { ThemeContext } from '../../context/ThemeContext';
import { getContrastColor } from '../../utils/colorUtils';
import { PageWrapper, Container, PageTitle, Section, SectionTitle, Text, StepGrid, StepCard } from './ComoFunciona.styles';

export default function ComoFunciona() {
  const { theme } = useContext(ThemeContext);
  const bg  = theme.background || '#000';
  const acc = theme.accent     || '#667eea';
  const txt = getContrastColor(bg);

  return (
    <PageWrapper bg={bg}>
      <Helmet>
        <title>Cómo funciona · Trastero</title>
        <meta name="description" content="Aprende a publicar, comprar y vender artículos de segunda mano en Trastero en pocos pasos." />
      </Helmet>
      <Container>
        <PageTitle color={txt}>¿Cómo funciona trasteroweb.es?</PageTitle>

        <Section>
          <Text color={txt}>
            trasteroweb.es es un marketplace de segunda mano entre particulares. Publicar es gratis y el contacto entre comprador y vendedor es directo, sin intermediarios.
          </Text>
        </Section>

        <Section>
          <SectionTitle accent={acc}>Para vendedores</SectionTitle>
          <StepGrid>
            <StepCard accent={acc}>
              <div className="num">1</div>
              <h3>Regístrate</h3>
              <p>Crea tu cuenta gratis en menos de un minuto.</p>
            </StepCard>
            <StepCard accent={acc}>
              <div className="num">2</div>
              <h3>Publica tu anuncio</h3>
              <p>Sube fotos, describe el artículo y fija el precio o propón un trueque.</p>
            </StepCard>
            <StepCard accent={acc}>
              <div className="num">3</div>
              <h3>Recibe mensajes</h3>
              <p>Los interesados te contactan directamente desde la plataforma.</p>
            </StepCard>
            <StepCard accent={acc}>
              <div className="num">4</div>
              <h3>Cierra el trato</h3>
              <p>Acordad precio, lugar y forma de pago directamente entre vosotros.</p>
            </StepCard>
          </StepGrid>
        </Section>

        <Section>
          <SectionTitle accent={acc}>Para compradores</SectionTitle>
          <StepGrid>
            <StepCard accent={acc}>
              <div className="num">1</div>
              <h3>Explora los anuncios</h3>
              <p>Navega por categorías o usa el buscador para encontrar lo que necesitas.</p>
            </StepCard>
            <StepCard accent={acc}>
              <div className="num">2</div>
              <h3>Contacta al vendedor</h3>
              <p>Envía un mensaje directamente desde el anuncio.</p>
            </StepCard>
            <StepCard accent={acc}>
              <div className="num">3</div>
              <h3>Cierra el trato</h3>
              <p>Acordad los detalles y realiza la transacción con seguridad.</p>
            </StepCard>
          </StepGrid>
        </Section>

        <Section>
          <SectionTitle accent={acc}>Totalmente gratuito</SectionTitle>
          <Text color={txt}>
            trasteroweb.es no cobra comisiones por publicar ni por vender. El servicio es gratuito para particulares. Las transacciones se realizan íntegramente fuera de la plataforma.
          </Text>
        </Section>
      </Container>
    </PageWrapper>
  );
}
